import CategoriesTab from './ApartmentsTab'
export default CategoriesTab


// WEBPACK FOOTER //
// ./src/components/ChannelTabs/DobovoTab/MappingTabs/ApartmentsTab/index.js